import React from "react";

export const AnimatedLogo: React.FC<{ className?: string }> = ({ className }) => (
    <svg
        className={className}
        width="74"
        height="27"
        viewBox="0 0 74 27"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
    >
        <rect
            className="arm1"
            x="32.5"
            y="1.75"
            width="29"
            height="4"
            fill="currentColor"
        />
        <rect
            className="arm2"
            x="12"
            y="21.25"
            width="29"
            height="4"
            fill="currentColor"
        />

        <circle cx="37" cy="13.5" r="4.25" fill="currentColor" />

        <circle className="spark1" cx="37" cy="13.5" r="1" fill="currentColor" />
        <circle className="spark3" cx="38" cy="13.5" r="1" fill="currentColor" />

        <circle
            className="spark2"
            cx="38.25"
            cy="14.75"
            r="1.25"
            fill="#currentColor"
        />
        <circle className="spark4" cx="37.5" cy="15" r="1.5" fill="#currentColor" />
    </svg>
);

export default AnimatedLogo;
